import { CustomField } from '@domain/product/models/CustomField';
import { Resource } from '@domain/base/Resource';
import { CustomFieldDataSource } from '../datasources/CustomFieldDataSource';
import {
  CreateCustomFieldDTO,
  UpdateCustomFieldDTO,
} from '../dto/CustomFieldDTO';
import { CustomFieldMapper } from '../mappers/CustomFieldMapper';

export class CustomFieldRepository {
  constructor(private customFieldDataSource: CustomFieldDataSource) {}

  async getCustomFields(): Promise<Resource<CustomField[]>> {
    try {
      const response = await this.customFieldDataSource.getCustomFields();
      return {
        status: 'success',
        data: response.map(CustomFieldMapper.toModel),
      };
    } catch {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to get custom fields' },
      };
    }
  }

  async createCustomField(data: CreateCustomFieldDTO): Promise<Resource<CustomField>> {
    try {
      const response = await this.customFieldDataSource.createCustomField(data);
      return {
        status: 'success',
        data: CustomFieldMapper.toModel(response),
      };
    } catch {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to create custom field' },
      };
    }
  }

  async updateCustomField(
    customFieldId: string,
    data: UpdateCustomFieldDTO
  ): Promise<Resource<CustomField>> {
    try {
      const response = await this.customFieldDataSource.updateCustomField(
        customFieldId,
        data
      );
      return {
        status: 'success',
        data: CustomFieldMapper.toModel(response),
      };
    } catch {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to update custom field' },
      };
    }
  }

  async deleteCustomField(customFieldId: string): Promise<Resource<void>> {
    try {
      await this.customFieldDataSource.deleteCustomField(customFieldId);
      return { status: 'success', data: undefined };
    } catch {
      return {
        status: 'error',
        error: { type: 'UnknownError', message: 'Failed to delete custom field' },
      };
    }
  }
}
